function getReferrer(event) {
  if (event.context?.page?.referrer) {
    return event.context.page.referrer;
  }

  if (document.referrer) {
    return document.referrer;
  }

  return window.localStorage.getItem('analytics-previous-url') ?? 'unknown';
}

function getEventContext(event, supplementalContextHelpers) {
  return {
    ...event.context,
    page: {
      ...event.context?.page,
      referrer: getReferrer(event),
    },
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      ...event.context?.screen,
    },
    traits: supplementalContextHelpers?.getSupplementalContext()?.user_traits,
    viewport: {
      height: window.innerHeight,
      width: window.innerWidth,
    },
  };
}

export default getEventContext;
